import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface CustomAxiosInstance extends AxiosInstance {
  before: (cb: (config: any) => any, order?: number) => CustomAxiosInstance;
  after: (cb: (response: any) => any, order?: number) => CustomAxiosInstance;
  error: (cb: (error: any) => any, order?: number) => CustomAxiosInstance;
}
export function createRequest(config?: AxiosRequestConfig): CustomAxiosInstance {
  // 生成 axios 实例
  const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 60 * 10000,
    ...config,
  });
  const callbackMaps = {
    // 前置拦截回调列表
    before: [],
    // 后置拦截回调列表
    after: [],
    // 错误拦截列表
    error: [],
  };
  // 订阅拦截回调
  ['before', 'after', 'error'].forEach((key) => {
    service[key] = (cb, order: number = 0) => {
      const list: Array<any> = callbackMaps[key];
      const insertIdx = list.findIndex((item) => item.order > order);
      list.splice(insertIdx, 0, { cb, order });
      return service;
    };
  });
  // 执行列表
  const runList = async (key, config) => {
    const result = await callbackMaps[key].reduce(async (config, { cb }) => {
      return cb(await config);
    }, Promise.resolve(config));
    if (key === 'error') return Promise.reject(result);
    return result;
  };
  // 请求拦截
  service.interceptors.request.use(
    (config) => runList('before', config),
    (error) => runList('error', error)
  );
  // 响应拦截
  service.interceptors.response.use(
    (config) => runList('after', config),
    (error) => runList('error', error)
  );
  return service as CustomAxiosInstance;
}
